<template>
  <div>
    <v-btn
      class="ma-2 no-display"
      tile
      outlined
      color="warning"
      @click="print()"
    >
      <v-icon left>mdi-printer</v-icon> Print <v-icon right></v-icon>
    </v-btn>
    <div id="document1" class="printdiv" v-if="lc_data != null">
      <v-row>
        <v-col cols="3" sm="3" md="3" align="right">
          <img
            :src="org_basic_data.school_logo"
            alt="school_logo"
            height="140px"
            width="170px"
          />
        </v-col>
        <v-col cols="6" sm="6" md="6">
          <center>
            <p>{{ org_basic_data.trust_name }}</p>
            <h1 style="text-transform: uppercase">
              {{ org_basic_data.school_name }}
            </h1>
            <p>( CBSE Affiliation - {{ org_basic_data.cbsc_no }})</p>
            <p>{{ org_basic_data.address }}&nbsp;</p>&nbsp;<p>Pin - {{org_basic_data.pin}}</p>
            <p>U - Dise : {{ lc_data.udise_no }}</p>
          </center>
        </v-col>
        <v-col cols="3" sm="3" md="3"></v-col>
      </v-row>
      <hr style="border: 1px dashed black" />
      <v-row>
        <v-col cols="4" sm="4" md="4"
          ><b>LC No:</b> {{ lc_data.certificate_no }}</v-col
        >
        <v-spacer></v-spacer>
        <v-col cols="4" sm="4" md="4"
          ><b>Student Id:</b> {{ lc_data.saral_id }}</v-col
        >
      </v-row>
      <h2 align="center">TRANSFER / LEAVING CERTIFICATE</h2>
      <div class="text-center" style="border: 1px solid black; width: 100%">
        <b>ORIGINAL</b>
      </div>
      <table class="lc-table">
        <tr>
          <td>Gr.No.</td>
          <td>{{ lc_data.gr_number }}</td>
        </tr>
        <tr>
          <td>Name of the Pupil</td>
          <td style="text-transform: uppercase;">{{ lc_data.fullname }}</td>
        </tr>
        <tr>
          <td>Father's / Guardian's Name</td>
          <td style="text-transform: uppercase;">{{ lc_data.father_full_name }}</td>
        </tr>
        <tr>
          <td>Mother's Name</td>
          <td style="text-transform: uppercase;">{{ lc_data.mother_first_name }}</td>
        </tr>
        <tr>
          <td>Nationality</td>
          <td style="text-transform: uppercase;">{{ lc_data.nationality }}</td>
        </tr>
        <tr>
          <td>Religion & Caste</td>
          <td style="text-transform: uppercase;">{{ lc_data.religion }} - {{ lc_data.caste }}</td>
        </tr>
        <tr>
          <td>
            Whether the candidate belongs to Schedule Cast or Schedule Tribe or
            OBC
          </td>
          <td style="text-transform: uppercase;">{{ lc_data.subcaste }}</td>
        </tr>
        <tr>
          <td>Date of first admission in the school with class</td>
          <td>{{ lc_data.doa }}  GRADE - {{ lc_data.admittedstandard }}</td>
        </tr>
        <tr>
          <td>Previous School Name</td>
          <td style="text-transform: uppercase;">{{ lc_data.last_school }}</td>
        </tr>
        <tr>
          <td>Date of Birth according to Admission Register In Christian Era <br>(in figures and word ) </td>
          <td style="text-transform: uppercase;">{{ lc_data.dob_fig }} <br>({{ lc_data.dob_words }})</td>
        </tr>
        <tr>
          <td>Place of Birth</td>
          <td style="text-transform: uppercase;">{{ lc_data.birth_place }}</td>
        </tr>
        <tr>
          <td>
            Class in which Studying at the time of leaving (in figures and words
            )
          </td>
          <td>
            GRADE - {{ lc_data.standard }}
            <span v-if="lc_data.std_in_words" style="text-transform: uppercase;"
              >({{ lc_data.std_in_words }})</span
            >
          </td>
        </tr>
        <tr>
          <td>School/Board Annual examination last taken with result</td>
          <td>GRADE - {{ lc_data.standard }} <span v-if="lc_data.std_in_words" style="text-transform: uppercase;">({{ lc_data.std_in_words }})</span></td>
        </tr>
        <tr>
          <td>Whether failed, if so once/twice in the same class</td>
          <td style="text-transform: uppercase;">{{ Whether_failed_in_same_class }}</td>
        </tr>
        <tr>
          <td>Subjects Studied</td>
          <td>
            <ul style="list-style-type: none; padding: 0">
              <li>
                <span v-for="(course, index) in lc_data.courses" :key="index" style="text-transform: uppercase;">
                  {{ course.course_name
                  }}<span v-if="index < lc_data.courses.length - 1">, </span>
                </span>
              </li>
            </ul>
          </td>
        </tr>
        <tr>
          <td>
            Whether qualified for promotion to the higher class, if so to which class <br>(in figures and word )
          </td>
          <td>
            <span v-if="is_promoted_to_next_standard.name === 'Yes'">
              GRADE - {{ lc_data.nextstandard.displayname }}&nbsp;
              <span v-if="lc_data.next_std_in_words" style="text-transform: uppercase;"
                > ({{ lc_data.next_std_in_words }})</span
              ></span
            ><span v-else style="text-transform: uppercase;">{{ is_promoted_to_next_standard.name }}</span>
          </td>
        </tr>
        <tr>
          <td>Whether NCC Cadet/Boy Scout/Girl Guide</td>
          <td style="text-transform: uppercase;">{{ whether_ncc_cadet }}</td>
        </tr>
        <tr>
          <td>
            Games Played or extra-curricular activities in which the pupil
            usually took part
          </td>
          <td style="text-transform: uppercase;">{{ lc_data.extra_curricular_activities }}</td>
        </tr>
        <tr>
          <td>General Progress</td>
          <td style="text-transform: uppercase;">{{ lc_data.progress }}</td>
        </tr>
        <tr>
          <td>General Conduct</td>
          <td style="text-transform: uppercase;">{{ lc_data.conduct }}</td>
        </tr>
        <tr>
          <td>Mother tongue</td>
          <td style="text-transform: uppercase;">{{ lc_data.mothertoungue }}</td>
        </tr>
        <tr>
          <td>Reason for leaving the school</td>
          <td style="text-transform: uppercase;">{{ lc_data.reason }}</td>
        </tr>
        <tr>
          <td>Any other remarks</td>
          <td>--</td>
        </tr>
        <tr>
          <td>Date of issue of certificate</td>
          <td>{{ lc_data.date_of_issue }}</td>
        </tr>
      </table>

      <!-- Replace the old <b class="f-size"> ... </b> with this -->
<div class="disclaimer f-size">
  *No change in any entry in this certificate shall be made except by the authority issuing it, and any infringement of this requirement is liable to involve the imposition of penalty as that of rustication (Prescribed by rule 17 Chapter Ⅱ and rule 30 section Ⅲ of grant-in-aid-code)
</div>
      <br /><br />
      <v-row class="f-size pb-5">
        <v-col cols="4" sm="4" md="4" align="center"
          ><b> Class Teacher Sign </b></v-col
        >
        <v-col cols="4" sm="4" md="4" align="center"><b> Checked by </b></v-col>
        <v-col cols="4" sm="4" md="4" align="center"
          ><b> Principal sign with Seal & Date </b></v-col
        >
      </v-row>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
  data() {
    return {
      lc_data: null,
      org_basic_data: null,
      org_id: null,
      Whether_failed_in_same_class: "",
      is_promoted_to_next_standard: "",
      whether_ncc_cadet: "",
      extra_curricular_activities: [],
    };
  },
  methods: {
    print() {
      this.$store.state.drawer = false;
      let that = this;
      window.onafterprint = function () {
        that.$store.state.drawer = true;
      };
      setTimeout(function () {
        window.print();
      }, 100);
    },
  },
  mounted() {
    this.lc_data = JSON.parse(localStorage.getItem("lc_data"));
    this.org_basic_data = JSON.parse(localStorage.getItem("org_basic_data"));
    this.is_promoted_to_next_standard = JSON.parse(
      localStorage.getItem("is_promoted_to_next_standard")
    );
    this.Whether_failed_in_same_class = JSON.parse(
      localStorage.getItem("Whether_failed_in_same_class")
    );
    this.whether_ncc_cadet = JSON.parse(
      localStorage.getItem("whether_ncc_cadet")
    );
    this.org_id = localStorage.getItem("EPS-org-id");
  },
};
</script>
<style scoped>

.printdiv {
  height: auto;
  margin-left: 15%;
  margin-right: 15%;
  background-color: white;
  padding: 0px 20px;
  margin: 4px 0;

  /* Keep layout stable */
  white-space: nowrap;
}

.lc-table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
}

.lc-table tr,
.lc-table td {
  border: 1px solid black;
}

.lc-table td {
  padding: 4px 8px !important;   
  font-size: 14px;             
  line-height: 1.25;            
  font-weight: 400;
  text-align: left;
  vertical-align: top;

  white-space: normal !important;
  word-break: break-word;
  overflow-wrap: break-word;
}

/* Label column */
.lc-table td:first-child {
  width: 45%;
  font-weight: bold;
}

/* Value column */
.lc-table td:last-child {
  width: 55%;
}

p {
  font-size: 14px;
  margin: 0;
  font-weight: 500;
}

h1 {
  font-size: 26px;
  margin: 6px 0 3px 0;
}

h2 {
  font-size: 20px;
  margin: 12px 0;
}

.disclaimer {
  margin: 8px 0 6px 0;
  font-size: 11px !important;  
  line-height: 1.25 !important;
  text-align: justify;
  font-weight: bold;

  white-space: normal !important;
  word-break: break-word;
  overflow-wrap: break-word;
  page-break-inside: avoid;
}

@media print {

  body * {
    visibility: hidden;
  }

  #document1,
  #document1 * {
    visibility: visible;
  }

  #document1 {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
  }

  .printdiv {
    margin: 0 !important;
    padding: 12px 30px 25px 30px !important; 
    box-sizing: border-box;
    background: white;
  }

  table,
  tr,
  td {
    page-break-inside: avoid;
  }

  .f-size {
    font-size: 14px !important;
    line-height: 1.3;
  }

  .v-btn,
  .no-display {
    display: none !important;
  }

  @page {
    size: A4 portrait;
    margin: 0;
  }
}

</style>
